import _ from 'underscore';
import Promise from 'bluebird';

export function getGridPreferences({
  gridName,
  fetchPaginationConfig,
}) {
  const services = [
    fetchPaginationConfig(gridName),
  ];

  return Promise.all(services)
    .then(([paginationConfig]) => {
      const { pageSize, orderbyInfo, sortableHeader } = paginationConfig;
      const result = {
        dataSource: {},
        plugins: {
          pagination: {
            pageSize,
          },
        },
      };

      if (orderbyInfo && orderbyInfo.length > 0) {
        result.dataSource.orderby = orderbyInfo;
        result.sortableHeader = _.pick(sortableHeader, 'name', 'directionIndex');
      }

      return result;
    });
}
